(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/models/gaming-history.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/models/gaming-history.js');

'use strict';

svs.player_login.models.GamingHistory = Backbone.Model.extend({
  url: "".concat(svs.core.jupiter.url(), "/player/1/playerhistorycurrent")
});

 })(window);